import { IDashDynamicRegPage } from "./dynamic-reg-page";
import { RestApi } from "@nkr/utils/rest-api";

export interface IDashGenericDynamicPage extends IDashDynamicRegPage {
}

export const useGenericDynamicPageApi = () =>
    new RestApi<IDashGenericDynamicPage, IDashGenericDynamicPage>(`${__API__}/dash/generic-pages`)
        .withCustomUpdatePath(`${__API__}/dash/generic-pages/{id}`)
        .withCustomDeletePath(`${__API__}/dash/generic-pages/{id}`)
        .makeHooks();
